import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationSpectrum } from '@app/api/interfaces/chart-data/correlation-spectrum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export enum FpCorrelationSpectrumActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
}

export interface FpCorrelationSpectrumActionGetData {
  type: FpCorrelationSpectrumActionType.GetData;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
}

export interface FpCorrelationSpectrumActionGetDataSuccesses {
  type: FpCorrelationSpectrumActionType.GetDataSuccesses;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  data: ICorrelationSpectrum[] | null;
}
export interface FpCorrelationSpectrumActionGetDataError {
  type: FpCorrelationSpectrumActionType.GetDataError;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  error: IApiBaseErrorResponse;
}
export interface FpCorrelationSpectrumActionToggleChartFullscreen {
  type: FpCorrelationSpectrumActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export type FpCorrelationSpectrumActions =
  | FpCorrelationSpectrumActionGetData
  | FpCorrelationSpectrumActionGetDataSuccesses
  | FpCorrelationSpectrumActionToggleChartFullscreen
  | FpCorrelationSpectrumActionGetDataError;
